import React, { useEffect } from "react";
import "./Header.css";
import images from "../../../../utilities/images/images";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getPyqYearwisePapersRequest,
  getPyqYearWiseRequest,
  setSelectedPyqYear,
} from "../../../../redux/exam/examSlice";

const Header = () => {
  const navigate = useHistory();
  const dispatch = useDispatch();

  const { pyqYears, selectedPyqYear,selectedPyqCategory, selectedType, paperName } = useSelector(
    (state) => state.examSlice
  );
  useEffect(() => {
    dispatch(
      getPyqYearWiseRequest({
        // topic: selectedType,
         topic: selectedPyqCategory,
        format: "year",
      })
    );
  }, [dispatch,  selectedPyqCategory,selectedType]);
  useEffect(() => {
    if (pyqYears?.length && !selectedPyqYear) {
      const firstYear = pyqYears[0].year;
      dispatch(setSelectedPyqYear(firstYear));

      dispatch(
        getPyqYearwisePapersRequest({
          year: firstYear,
          // target: selectedType,
          target: selectedPyqCategory,
        })
      );
    }
  }, [pyqYears, selectedPyqYear, selectedPyqCategory, dispatch, selectedType]);

  const handleBackClick = () => {
    navigate.push("/practice");
  };

  const handleYearChange = (e) => {
    const selectedYear = e.target.value;
    dispatch(setSelectedPyqYear(selectedYear));

    dispatch(
      getPyqYearwisePapersRequest({
        year: selectedYear,
        // target: selectedType,
         target: selectedPyqCategory,
      })
    );
  };

  return (
    <div className="aits_header">
      <div
        className="aits_header_left"
        onClick={handleBackClick}
        style={{ cursor: "pointer" }}
      >
        <img src={images.backBtn} alt="backbtn" />
        <div>{paperName}</div>
      </div>

      {/* {selectedType === "year wise" && ( */}
        <div className="aits_header_center"> 
          <select
            className="pyq_dropdown"
            value={selectedPyqYear}
            onChange={handleYearChange}
          >
            {pyqYears?.map((item, index) => (
              <option key={index} value={item.year}>
                {item.year}
              </option>
            ))}
          </select>
        </div>
      {/* )} */}
    </div>
  );
};

export default Header;
